import global from '../../../config/global';

const esBaseURL = global.apisUrl + '/external-support';

export const getApplicableIndustryURL = esBaseURL + '/all-applicable-industries';

export const esProgramURL = (id) => esBaseURL + `/save-program${id ? '/' + id : ''}`;

export const deleteProgram = (id) => esBaseURL + `/delete/${id}`;

export const esProgramListURL = esBaseURL + `/list`;

export const allESProgramListURL = esBaseURL + `/all-list`;

export const addESProgramURL = esBaseURL + '/add';

export const companyESProgramListURL = esBaseURL + `/company-es-list`;

export const removeCompanyProgramURL = (id) => esBaseURL + `/remove-es-program/${id}`;
